import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Switch,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { useSelector } from "react-redux";
import { useFetch } from "../../hooks";
import { urls } from "../../urls/urls";
import { BASE_URL_TEST } from "../../utils/baseUrl";

export default function NotificationSettings() {
  const loginToken = useSelector((state) => state.user.logintoken);
  const notificationDetails = useSelector(
    (state) => state.user.userdetails.notifications,
  );
  const userDetails = useSelector((state) => state.user.userdetails);
  console.log("loginToken", loginToken);
  const [isModalOpen, setModalOpen] = useState(false);
  const [snackbarState, setSnackbarState] = useState({
    message: "",
    status: "",
  });
  const {
    data: updatedNotificationData,
    isLoading: updatedNotificationLoading,
    error: updatedNotificationError,
    fetchData: fetchNotificationData,
  } = useFetch(BASE_URL_TEST + urls("notificationSettings"), {
    method: "PUT",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const [notifications, setNotifications] = useState({
    emailNotifications: notificationDetails.emain_notification || false,
    pushNotifications: notificationDetails.push_notification || false,
    orderAssign: notificationDetails.order_assign || false,
    orderDelivery: notificationDetails.order_delivery || false,
    vendorLowStockAlert: notificationDetails.vendor_low_stock_alert || false,
    userCreation: notificationDetails.user_creation || false,
    vendorCreation: notificationDetails.vendor_creation || false,
    bannerCreationVendorAdd: notificationDetails.banner_creation || false,
    withdrawCondition: notificationDetails.withdraw_conditon || false,
    moneyThershold: notificationDetails.money_threshold || false,
    customerQueries: notificationDetails.customer_queies || false,
  });

  const handleToggle = (key) => {
    setNotifications((prevState) => {
      const updatedNotifications = { ...prevState, [key]: !prevState[key] };
      return updatedNotifications;
    });
  };

  useEffect(() => {
    setNotifications({
      emailNotifications: notificationDetails.emain_notification || false,
      pushNotifications: notificationDetails.push_notification || false,
      orderAssign: notificationDetails.order_assign || false,
      orderDelivery: notificationDetails.order_delivery || false,
      vendorLowStockAlert: notificationDetails.vendor_low_stock_alert || false,
      userCreation: notificationDetails.user_creation || false,
      vendorCreation: notificationDetails.vendor_creation || false,
      bannerCreationVendorAdd: notificationDetails.banner_creation || false,
      withdrawCondition: notificationDetails.withdraw_conditon || false,
      moneyThershold: notificationDetails.money_threshold || false,
      customerQueries: notificationDetails.customer_queies || false,
    });
  }, [notificationDetails]);

  // Handle Save action
  const handleSave = () => {
    const saveBody = {
      user_id: userDetails.user_id,
      notifications: {
        emain_notification: notifications.emailNotifications,
        push_notification: notifications.pushNotifications,
        order_assign: notifications.orderAssign,
        order_delivery: notifications.orderDelivery,
        user_creation: notifications.userCreation,
        vendor_creation: notifications.vendorCreation,
        banner_creation: notifications.bannerCreationVendorAdd,
        withdraw_conditon: notifications.withdrawCondition,
        money_threshold: notifications.moneyThershold,
        customer_queies: notifications.customerQueries,
        vendor_low_stock_alert: notifications.vendorLowStockAlert,
      },
    };
    fetchNotificationData(saveBody);
  };

  useEffect(() => {
    if (updatedNotificationError) {
    } else if (
      updatedNotificationData &&
      updatedNotificationData["status"] === true
    ) {
      setSnackbarState({
        ...snackbarState,
        message: updatedNotificationData["message"],
        status: updatedNotificationData["status"],
      });
      setModalOpen(true);
    } else if (
      updatedNotificationData &&
      updatedNotificationData["status"] === false
    ) {
      setSnackbarState({
        ...snackbarState,
        message: updatedNotificationData["message"],
        status: updatedNotificationData["status"],
      });
      setModalOpen(true);
    }
  }, [updatedNotificationData, updatedNotificationError]);

  //close button
  const handleClose = () => {
    setModalOpen(false);
  };

  return (
    <Box
      sx={{
        border: "1px solid #ccc",
        borderRadius: "8px",
        padding: 2,
        backgroundColor: "#fff",
      }}
    >
      <Typography variant="h6" sx={{ fontWeight: "bold", marginBottom: "8px" }}>
        Notification Preferences
      </Typography>
      <Typography variant="body2" sx={{ color: "#666", marginBottom: "20px" }}>
        Choose how you want to be notified about important updates.
      </Typography>
      <Box>
        {[
          { label: "Email Notifications", key: "emailNotifications" },
          { label: "Push Notifications", key: "pushNotifications" },
          { label: "Order Assign", key: "orderAssign" },
          { label: "Order Delivery", key: "orderDelivery" },
          { label: "User Creation", key: "userCreation" },
          { label: "Vendor Creation", key: "vendorCreation" },
          {
            label: "Banner Creation / Vendor Add",
            key: "bannerCreationVendorAdd",
          },
          { label: "Withdraw Condition", key: "withdrawCondition" },
          { label: "Money Thershold", key: "moneyThershold" },
          { label: "Customer Queries", key: "customerQueries" },
          { label: "Vendor Low Stock Alert", key: "vendorLowStockAlert" },
        ].map((item) => (
          <Box
            key={item.key}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: "10px",
            }}
          >
            <Typography sx={{ fontSize: "14px" }}>{item.label}</Typography>
            <Switch
              checked={notifications[item.key]}
              onChange={() => handleToggle(item.key)}
            />
          </Box>
        ))}
      </Box>
      <Button
        variant="contained"
        sx={{
          backgroundColor: "#007b5e",
          color: "#fff",
          marginTop: "20px",
          "&:hover": {
            backgroundColor: "#005f47",
          },
        }}
        onClick={handleSave}
      >
        Save Changes
      </Button>
      {/* Modal Dialog for Success */}
      <Dialog open={isModalOpen}>
        <DialogTitle>
          {snackbarState.status === true ? "Success" : "Error"}
        </DialogTitle>
        <DialogContent>
          <Typography
            variant="body1"
            sx={{
              color: snackbarState.status === true ? "green" : "red",
            }}
          >
            {snackbarState.message}
          </Typography>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={handleClose}
            sx={{
              textTransform: "none",
              borderRadius: 2,
              alignSelf: "center",
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
